const Cookies = () => (
<main>
    <h1>Our Cookies</h1>
    <p>Check out our mouth-watering lineup of cookies — baked daily and always kooky!</p>
  </main>
);

export default Cookies;